class ChangeItemBuilder {
    static buildItem(query, payload) {
        const { facetId, facetValueId, type, facetValueText } = payload;
        if (type === 'text') {
            if (facetValueText) {
                return { type: 'eq', value: facetValueText };
            }
            const { facet: facets = [] } = query.getLastResponse() || {};
            const { value: facetValues = [] } = facets.find(({ name }) => name === facetId) || {};
            const facetValue = facetValues.find(({ id }) => id === facetValueId)?.text || '';
            return { type: 'eq', value: facetValue };
        }
        return facetValueId;
    }
}
export default ChangeItemBuilder;
